import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// Externals
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Material helpers
import { withStyles } from '@material-ui/core';

// Material components
import { Typography } from '@material-ui/core';

// Shared components
import { Paper } from 'components';

// Component styles
import styles from './styles';

class WebsiteCard extends Component {
  render() {
    const { classes, className, website, citations } = this.props;

    const rootClassName = classNames(classes.root, className);

   // let citationsCount = website.relationships.citations.count;
   let numCitations1 = citations.find(c => c.websiteId === website.id);
   let numCitations = numCitations1 ? numCitations1.count : 0
    return (
      <Link to={`/website/${website.id}`}>
        <Paper className={rootClassName}>
          <div className={classes.details}>
            <Typography
              className={classes.title}
              variant="h4"
            >
              {this.title()}
            </Typography>
            <Typography
              className={classes.description}
              variant="body1"
            >
            {numCitations + " Quotations"}
            </Typography>
          </div>
        </Paper>
      </Link>
    );
  }
  /*quotes(){
    let visibleHeadwords = Object.values(this.props.citations.attributes).filter(citation => citation.websiteId==this.props.website.id);
    return (visibleHeadwords.length + " Quotations");
  } */ 
  title(){
    if(this.props.website.title!=undefined){
      return(
        this.props.website.title
      );
    } else if(this.props.website.siteName!=undefined){
      return(
        this.props.website.siteName
      );
    }
  }
}

WebsiteCard.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  website: PropTypes.object.isRequired
};

export default withStyles(styles)(WebsiteCard);
